export const AI_COMPLIANCE_REQUIRED_EVENT = 'ticket-buddy:ai-compliance-required'

export class AiComplianceAcceptanceCancelledError extends Error {
  constructor() {
    super('AI compliance acceptance was cancelled')
    this.name = 'AiComplianceAcceptanceCancelledError'
  }
}

let pendingAcceptance: Promise<void> | null = null
let resolvePendingAcceptance: (() => void) | null = null
let rejectPendingAcceptance: ((error: Error) => void) | null = null

function clearPendingAcceptance(): void {
  pendingAcceptance = null
  resolvePendingAcceptance = null
  rejectPendingAcceptance = null
}

export function requestAiComplianceAcceptance(): Promise<void> {
  if (pendingAcceptance) return pendingAcceptance
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('AI compliance acceptance requires a browser'))
  }

  pendingAcceptance = new Promise<void>((resolve, reject) => {
    resolvePendingAcceptance = resolve
    rejectPendingAcceptance = reject
  })
  window.dispatchEvent(new CustomEvent(AI_COMPLIANCE_REQUIRED_EVENT))
  return pendingAcceptance
}

export function resolveAiComplianceAcceptance(): void {
  const resolve = resolvePendingAcceptance
  clearPendingAcceptance()
  resolve?.()
}

export function cancelAiComplianceAcceptance(): void {
  const reject = rejectPendingAcceptance
  clearPendingAcceptance()
  reject?.(new AiComplianceAcceptanceCancelledError())
}
